import {
  ExpandedState,
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useState } from "react";
import { JobsWithChildren } from "src/pages/ExportPage/store/fetchers";

import { jobsTableColumns } from "./jobsTableColumns";

export const JobsTable = ({ jobs }: { jobs: JobsWithChildren[] }) => {
  const [expanded, setExpanded] = useState<ExpandedState>({});

  const table = useReactTable({
    data: jobs,
    columns: jobsTableColumns,
    state: {
      expanded,
    },
    onExpandedChange: setExpanded,
    getSubRows: (row) => row.children,
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
  });

  return (
    <div className="g-table">
      <table className="g-table__table" style={{ width: "100%" }}>
        <thead className="g-table__head">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr className="g-table__row" key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th
                    className="g-table__cell g-table__cell_edge-padding"
                    key={header.id}
                    colSpan={header.colSpan}
                  >
                    {header.isPlaceholder ? null : (
                      <div>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody className="g-table__body">
          {table.getRowModel().rows.map((row) => {
            return (
              <tr
                className="g-table__row g-table__row_interactive"
                key={row.id}
              >
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td
                      className="g-table__cell g-table__cell_edge-padding"
                      key={cell.id}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
